import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import Focus from './Focus';
import { Kanban } from 'libs/kanban';
import { TabPaneStyles } from './styles';

const TabPaneFocuses = ({ setStatus, focuses, setFocuses }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedFocus, setSelectedFocus] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteFocus = async () => {
    return seo.deleteTypeItem('focuses', selectedFocus.id);
  };

  return (
    <TabPaneStyles>
      <span>{translate('Focuses')}</span>
      <div className="d-flex flex-column gap-2">
        {(Array.isArray(focuses) ? focuses.filter(Boolean) : []).map((focus) => (
          <Focus
            key={focus?.id}
            id={focus?.id}
            name={focus?.name}
            setItems={setFocuses}
            index={focuses.filter(Boolean).findIndex((col) => col.id === focus.id)}
            total={focuses.filter(Boolean).length}
            isNew={focus.isNew}
            setSelectedItem={setSelectedFocus}
            setIsOpenModalDelete={setIsOpenModalDelete}
            setStatus={setStatus}
          />
        ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() => {
            if (!Array.isArray(focuses)) {
              setFocuses([{ id: 'temp-1', name: '', isNew: true }]);
            } else {
              setFocuses([
                ...focuses.filter(Boolean),
                { id: `temp-${focuses.filter(Boolean).length + 1}`, name: '', isNew: true },
              ]);
            }
          }}
        >
          <i className="bx bx-plus" />
          {translate('Add focus')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedFocus}
        setItems={setFocuses}
        setStatus={setStatus}
        onDelete={deleteFocus}
        headerText="Delete focus"
        bodyText="Are you sure you want to delete the focus {{item}}?"
      />
    </TabPaneStyles>
  );
};

TabPaneFocuses.propTypes = {
  setStatus: PropTypes.func.isRequired,
  focuses: PropTypes.array.isRequired,
  setFocuses: PropTypes.func.isRequired,
};

export default TabPaneFocuses;
